import { CategoryIconList } from "~/const"

export const categoryIcon = (_slug: string): string => {
  const iconSrc = CategoryIconList.filter((_icon) => {
    return _icon.key === _slug ? _icon.key : ""
  })
  return iconSrc[0] ? iconSrc[0].value : ""
}

export const getSubCategoryImageUrl = (_slug: string): string => {
  return `/images/site/journal/index/sub_category_icon/${_slug}.jpg`
}

export const getJournalPath = (journal: {
  product_category?: { slug: string }
  product_sub_category?: { slug: string }
  slug: string
}): string => {
  return `/journals/${journal.product_category?.slug || "-"}/${journal.product_sub_category?.slug || "-"}/${
    journal.slug
  }`
}
